var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTable = function SvgTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T4.308 2.5h15.384q.758 0 1.283.525t.525 1.283v15.384q0 .758-.525 1.283t-1.283.525zm6.942-6.548H4v4.74a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h6.943zm1.5 0V20h6.942a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22v-4.741zm-1.5-1.5V8.384H4v5.068zm1.5 0H20V8.384h-7.25zM4 6.885h16V4.308a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H4.307a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22z"
  })));
};
export default SvgTable;